<div class="flex flex-column gap-3">
    <div class="grid">
        <div class="col-12">
            <label for="descriptionEtapeManuelle" class="block mb-2">Description</label>
            <input #champDescription type="text" pInputText id="descriptionEtapeManuelle" [(ngModel)]="description"
                autocomplete="off" class="w-full" (keyup.enter)="confirmer()" />
            @if (submitted && !description?.trim()) {
                <small class="p-error block mt-1">La description est requise.</small>
            }
        </div>
        <div class="col-12">
            <label for="categorieEtapeManuelle" class="block mb-2">Code de catégorie</label>
            <p-dropdown inputId="categorieEtapeManuelle" [options]="categoriesEntretien" [(ngModel)]="categorie"
                optionLabel="description" [showClear]="true" filter="true" filterBy="code,description" appendTo="body"
                placeholder="Sélectionner une catégorie..." styleClass="w-full">
                <ng-template pTemplate="selectedItem">
                    @if (categorie) {
                        <div>{{ categorie.code }} - {{ categorie.description }}</div>
                    }
                </ng-template>
                <ng-template let-categorieItem pTemplate="item">
                    <div>{{ categorieItem.code }} - {{ categorieItem.description }}</div>
                </ng-template>
            </p-dropdown>
        </div>
        <div class="col-12">
            <label for="noteEtapeManuelle" class="block mb-2">Note</label>
            <input type="text" pInputText id="noteEtapeManuelle" [(ngModel)]="note" autocomplete="off" class="w-full"
                (keyup.enter)="confirmer()" />
        </div>
    </div>

    <div class="flex justify-content-end gap-2 pt-2 border-top-1 surface-border">
        <p-button label="Annuler" icon="pi pi-ban" severity="secondary" [text]="true"
            (onClick)="annuler()"></p-button>
        <p-button [label]="modeEdition ? 'Modifier' : 'Ajouter'" [icon]="modeEdition ? 'pi pi-check' : 'pi pi-plus'"
            (onClick)="confirmer()"></p-button>
    </div>
</div>
